import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/lottery/count/list'
    return request.post(url,data)
}

export function all() {
    let url = '/lottery/count/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/lottery/count/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/lottery/count/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/lottery/count/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/lottery/count/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/lottery/count/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/lottery/count/dmz/options'
    return request.get(url)
}
